import { useNavigate } from 'react-router-dom';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useGuest } from '@/contexts/GuestContext';
import { MascotImage } from '@/components/mascot/MascotImage';

interface GuestActionSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  message?: string;
  intendedAction?: { route: string; action?: string };
}

export const GuestActionSheet = ({ 
  open, 
  onOpenChange,
  message = 'Sign in or sign up to use this feature',
  intendedAction
}: GuestActionSheetProps) => {
  const navigate = useNavigate();
  const { exitGuestMode, setPendingAction } = useGuest();

  const handleSignIn = () => {
    if (intendedAction) {
      setPendingAction(intendedAction);
    }
    exitGuestMode();
    onOpenChange(false);
  };

  const handleSignUp = () => {
    if (intendedAction) {
      setPendingAction(intendedAction);
    }
    exitGuestMode();
    onOpenChange(false);
  };

  const handleNotNow = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="rounded-t-3xl" style={{ paddingBottom: 'calc(1.5rem + var(--safe-area-bottom, 0px))' }}>
        <div className="flex flex-col items-center gap-4 py-4">
          <div className="w-24 h-24">
            <MascotImage variant="thinking" className="w-full h-full" />
          </div>
          
          <SheetHeader className="text-center space-y-2">
            <SheetTitle className="text-xl">
              Ready to Join In?
            </SheetTitle>
            <SheetDescription className="text-base">
              {message}
            </SheetDescription>
          </SheetHeader>

          <div className="flex flex-col gap-3 w-full mt-2">
            <Button 
              onClick={handleSignUp}
              className="w-full"
              size="lg"
            >
              Create Account
            </Button>
            <Button 
              onClick={handleSignIn}
              variant="outline"
              className="w-full"
              size="lg"
            >
              Sign In
            </Button>
            <button
              onClick={handleNotNow}
              className="text-sm text-muted-foreground hover:text-foreground transition-colors py-2"
            >
              Not now
            </button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
